<template>
  <div style="width: 250px">
    <div class="row align-items-center">
      <div class="col-md-8">
        <select
          v-model="selectedFile"
          class="form-select style-select"
          aria-label="Pilih File Download"
        >
          <option disabled value="">- Pilih File -</option>
          <option
            v-for="item in availableFiles"
            :key="item.value"
            :value="item.value"
            :disabled="!item.url"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div class="col-md-4">
        <a
          v-if="activeDownloadUrl"
          :href="activeDownloadUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i
            :class="downloadIconClass"
            aria-hidden="true"
            style="font-size: 20px"
            data-toggle="tooltip"
            data-placement="top"
            :title="downloadTitle"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileDropdownDownload',
  props: {
    row: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedFile: '',
    }
  },
  computed: {
    // Memetakan semua opsi file dan URL-nya berdasarkan logika fallback
    availableFiles() {
      return [
        {
          value: 'verdok',
          label: 'Verdok',
          url: this.row.file_ba_verdok,
          title: 'Unduh file verifikasi dokumen',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'tagihan_1',
          label: 'Tagihan 1',
          url: this.row.file_tagihan_i,
          title: 'Unduh file tagihan 1',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'tagihan_2',
          label: 'Tagihan 2',
          url: this.row.file_tagihan_ii,
          title: 'Unduh file tagihan 2',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'tagihan_3',
          label: 'Tagihan 3',
          url: this.row.file_tagihan_iii,
          title: 'Unduh file tagihan 3',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'pembayaran',
          label: 'Bukti Pembayaran',
          url: this.row.bukti_pembayaran,
          title: 'Unduh file bukti pembayaran',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'surattugas',
          label: 'Surat Tugas',
          url: this.row.filename_final_surat_tugas || this.row.filename_konsep_surat_tugas,
          title: 'Unduh file surat tugas',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'undangan',
          label: 'Undangan',
          url: this.row.filename_final_undangan || this.row.filename_konsep_undangan,
          title: 'Unduh file undangan',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'ba',
          label: 'Berita Acara',
          url: this.row.file_ba_vertek,
          title: 'Unduh file berita acara',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'ba_penolakan',
          label: 'Berita Acara Penolakan',
          url: this.row.file_ba_tidak_bayar,
          title: 'Unduh file berita acara penolakan',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'memo',
          label: 'Memorandum',
          url: this.row.file_final_memorandum || this.row.file_konsep_memorandum,
          title: 'Unduh file memo',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'shp',
          label: 'File SHP',
          url: this.row.file_shp,
          title: 'Unduh file SHP',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'resume',
          label: 'Resume Permohonan',
          url: this.row.file_resume_permohonan,
          title: 'Unduh file resume permohonan',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'persetujuan',
          label: 'Final Surat Persetujuan',
          url: this.row.file_persetujuan,
          title: 'Unduh file persetujuan',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'epersetujuan',
          label: 'Final Surat Persetujuan Elektronik',
          url: this.row.file_izin_ttd,
          title: 'Unduh file persetujuan elektronik',
          icon: 'fa fa-cloud-download',
        },
        {
          value: 'oss',
          label: 'Final Persetujuan OSS',
          url: this.row.file_final_oss,
          title: 'Unduh file persetujuan OSS',
          icon: 'fa fa-cloud-download',
        },
      ]
    },

    // Mendapatkan konfigurasi file yang sedang dipilih
    selectedFileObj() {
      return this.availableFiles.find((f) => f.value === this.selectedFile)
    },

    // URL untuk tautan download
    activeDownloadUrl() {
      return this.selectedFileObj ? this.selectedFileObj.url : null
    },

    // Judul tooltip
    downloadTitle() {
      return this.selectedFileObj ? this.selectedFileObj.title : ''
    },

    // Kelas ikon download
    downloadIconClass() {
      return this.selectedFileObj ? this.selectedFileObj.icon : 'fa fa-cloud-download'
    },
  },
  watch: {
    // Reset nilai select jika row berubah
    row: {
      handler() {
        this.selectedFile = ''
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.style-select {
  width: 150px;
  margin-right: 10px;
}
</style>